import React from 'react'

import { gtmEvent } from 'utils/client/analitics'
import { scrollToBlock } from 'utils/client/scroll'

export const useCollectWithChecks = ({
  isPersonalInfoReady,
  errors,
  remotePersonalInfoSubmit,
  isOrderCollected,
  isFetching,
  handleCollect,
}) => {
  return React.useCallback(() => {
    if (!isPersonalInfoReady) {
      remotePersonalInfoSubmit()
      gtmEvent({
        event: 'Click Button Next - Error',
        description: errors ? JSON.stringify(errors) : 'all',
      })

      return false
    }

    if (!isOrderCollected && !isFetching) {
      handleCollect()
      gtmEvent({ event: 'Click Button Next - Success' })

      return true
    }

    return false
  }, [
    isPersonalInfoReady,
    errors,
    isOrderCollected,
    isFetching,
    remotePersonalInfoSubmit,
    handleCollect,
  ])
}

export const useResetCollectDataStep = ({
  menuNode,
  piFormRef,
  handleCollectReset,
}) => {
  return React.useCallback(() => {
    if (piFormRef) {
      scrollToBlock(piFormRef, menuNode)
    }

    gtmEvent({ event: 'Button - Back to Order - Clicked' })

    handleCollectReset()
  }, [piFormRef, handleCollectReset, menuNode])
}
